module.exports = __webpack_public_path__ + "static/media/programimg1.f283bc28.webp";